import { Component, Input } from '@angular/core';

import { clienteCarteiraTipoProjetada, clienteCarteiraTipoRealizada } from '../../cliente-carteira-tipo';

@Component({
    selector: 'sgt-cliente-carteira-tipo-realizada-perc-progress',
    templateUrl: './cliente-carteira-tipo-realizada-perc-progress.component.html',
    styleUrls: ['./cliente-carteira-tipo-realizada-perc-progress.component.less']
})
export class ClienteCarteiraTipoRealizadaPercProgressComponent {
    tipoCarteiraProjetada = clienteCarteiraTipoProjetada;
    tipoCarteiraRealizada = clienteCarteiraTipoRealizada;

    /** Percentual da carteira realizada */
    @Input() perc: number;
}
